module.exports = __webpack_public_path__ + "img/main_image.95e734f5.jpg";